"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Environment = void 0;
const api_shared_js_1 = require("@tableau/api-shared-js");
const ConnectedServer_1 = require("../Impl/ConnectedServer");
const WorkbookFormattingEnvUtil_1 = require("./WorkbookFormattingEnvUtil");
/**
 * Implementation of the external environment namespace.
 * Environment does not follow the Impl pattern as it is
 * just a property bag.
 * First class extensions can get to ConnectedServer with: environment['connectedServer']
 */
class Environment {
    constructor(extensionEnvironment) {
        this._apiVersion = api_shared_js_1.ApiVersion.Instance && api_shared_js_1.ApiVersion.Instance.formattedValue; // maj.min.fix (no build)
        this._context = api_shared_js_1.InternalToExternalEnumMappings.extensionContext.convert(extensionEnvironment.extensionContext);
        this._isExporting = extensionEnvironment.isExporting;
        this._formatting = WorkbookFormattingEnvUtil_1.WorkbookFormattingEnvUtil.convertToWorkbookFormatting(extensionEnvironment.workbookFormatting);
        this._language = extensionEnvironment.extensionLanguage;
        this._country = extensionEnvironment.extensionCountry;
        this._locale = extensionEnvironment.extensionLocale;
        this._workbookLocale = extensionEnvironment.workbookLocale;
        this._mode = api_shared_js_1.InternalToExternalEnumMappings.extensionMode.convert(extensionEnvironment.extensionMode);
        this._operatingSystem = extensionEnvironment.operatingSystem;
        this._tableauVersion = extensionEnvironment.tableauVersion;
        this._uniqueUserId = extensionEnvironment.uniqueUserId;
        this._exportedMediaType = extensionEnvironment.exportedMediaType
            ? api_shared_js_1.InternalToExternalEnumMappings.exportedMediaType.convert(extensionEnvironment.exportedMediaType)
            : undefined;
        // If we have a userId, then we are a first class extension
        if (extensionEnvironment.userId) {
            this.connectedServer = new ConnectedServer_1.ConnectedServer(extensionEnvironment.userId, extensionEnvironment.siteId, extensionEnvironment.siteNamespace, extensionEnvironment.workbookId);
            this.featureFlags = extensionEnvironment.featureFlags;
        }
    }
    get apiVersion() {
        return this._apiVersion;
    }
    get context() {
        return this._context;
    }
    get workbookFormatting() {
        return this._formatting;
    }
    get language() {
        return this._language;
    }
    get country() {
        return this._country;
    }
    get locale() {
        return this._locale;
    }
    get workbookLocale() {
        return this._workbookLocale;
    }
    get mode() {
        return this._mode;
    }
    get operatingSystem() {
        return this._operatingSystem;
    }
    get tableauVersion() {
        return this._tableauVersion;
    }
    get uniqueUserId() {
        return this._uniqueUserId;
    }
    get isExporting() {
        return this._isExporting;
    }
    get exportedMediaType() {
        return this._exportedMediaType;
    }
}
exports.Environment = Environment;
//# sourceMappingURL=Environment.js.map